import ChatInfo from './ChatInfo';
import ChatUser from './ChatUser';
import ChatBox from './ChatBox';
import ChatWrapup from './ChatWrapup';
import ChatSBS from './ChatSBS';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const ChatDetails = () => {

    const chatSliceData = useSelector((state:any)=>{return state.chatSlice});

    if(process.env.REACT_APP_AWS_CCP_SbSAvailable === "1") {
        const customViewsIframe = document.querySelector('#customviews-container')!;
        customViewsIframe.setAttribute('style', "height: 43rem; width: 92%; margin: 0 auto; display: block; margin-left: 105px; margin-top: 10px; background-color: white;");
    }

    useEffect(() => {
        //Aquí es la razón de por qué no funciona SbS si no es con los atributos (no sé que tendríamos que cambiar para que funcione con la nueva cajita)
        if("DefaultFlowForAgentUI" in chatSliceData.selectedInfo) {
            const contactflowId = chatSliceData.selectedInfo["DefaultFlowForAgentUI"]["value"];
            const customViewsIframe = document.querySelector('#customviews-container')!;
            const currentContactId = chatSliceData.selectedChat;
            customViewsIframe.setAttribute('src', `${process.env.REACT_APP_AWS_CCP_SBS_URL}stargate/app?contactFlowId=${contactflowId}&currentContactId=${currentContactId}`);
        }
    }, []);

    return (
        <div className="main-content">
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-12'>
                        <ChatInfo />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-3'>
                        <ChatUser />
                    </div>
                    <div className='col-md-6'>
                       <ChatBox />
                    </div>
                    <div className='col-md-3'>
                        <ChatWrapup />
                    </div>
                    {process.env.REACT_APP_AWS_CCP_SbSAvailable === "1" ? (
                        <div className='col-md-12'>
                            <ChatSBS />
                        </div>
                    ):(
                        <></>
                    )}
                </div>
            </div>
        </div>
    )
}
export default ChatDetails;
